import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router"
import { ClienteLogin } from '../../../views/login/cliente_login';
import { UbicacionEntity } from "../../../views/masivos/datosGenerales/entities/ubicacion_entity"
import { CIUDADES } from "./entity/ciudades";
import { Cliente } from "../../../views/login/cliente_login";
import { ClienteIndividualEntity } from "../../../views/masivos/datosGenerales/entities/datos_generales_individual_entity";
import { DatosGeneralesService } from "../../../views/masivos/datosGenerales/datos-generales.service";
import { HandleError } from "../utils/handleError.component";
import { ConsultarUsuarioMasivos } from "../utils/consultarUsuarioMasivos";
import { SessionStorageService, SessionStorage } from "ngx-webstorage";


declare var jQuery: any;

@Component({
    selector: 'cabecera',
    templateUrl: 'cabecera.template.html',
    styleUrls: ["cabecera.style.css"]
})

export class Cabecera implements OnInit {
    NombreUsuario: string;
    usuario: ClienteLogin;
    comboCiudad: UbicacionEntity[];
    inicial: number;
    lengthCombo: boolean;
    nombreUser: Cliente;
    clienteMasivosIndividual: ClienteIndividualEntity;

    constructor(private sesionStorageService: SessionStorageService, private router: Router, private datosGeneralesIndividualSevice: DatosGeneralesService, private handleError: HandleError, private consultarMasivo: ConsultarUsuarioMasivos) { }

    ngOnInit(): void {
            this.usuario = jQuery.parseJSON(this.sesionStorageService.retrieve("usuario"));
            this.nombreUser = jQuery.parseJSON(this.sesionStorageService.retrieve("usermasivos"));
            this.consultarTodo();
            this.sesionStorageService.observe("usuario").subscribe(v => {
                this.usuario = jQuery.parseJSON(v);
                this.consultarTodo();
            });
            this.sesionStorageService.observe("usermasivos").subscribe(v => {
                this.nombreUser = jQuery.parseJSON(v);
                this.consultarTodo();
            });
    }

    consultarTodo(){
        this.consultarMasivo.iniciarUsuarioMasivo();
            if (this.usuario != null) {
                if (this.usuario.Masivos != null) {
                    if (this.router.url.includes("masivos")) {
                        this.comboCiudad = [];
                        if (this.nombreUser == null) {
                            this.inicial = this.usuario.Masivos[0].Ciudad;
                        } else {
                            this.inicial = this.nombreUser.Ciudad;
                        }
                        this.lengthCombo = this.usuario.Masivos.length > 1 ? true : false;
                        this.usuario.Masivos.forEach(element => {
                            CIUDADES.forEach(a => {
                                if (a.Codigo == element.Ciudad) {
                                    this.comboCiudad.push(a);
                                }
                            });
                        });
                    } else {
                        this.lengthCombo = false;
                    }
                }
            }
            try{
            this.NombreUsuario = JSON.parse(this.sesionStorageService.retrieve("NombreUser"));
            }catch(e){
                this.NombreUsuario = this.sesionStorageService.retrieve("NombreUser");
            }
            this.sesionStorageService.observe("NombreUser").subscribe(v => {
                try{
                this.NombreUsuario = JSON.parse(v);
                }catch(e){
                    this.NombreUsuario = v;
                }
            });
    }

    onCiudadChange(codCiudad): void {
        this.usuario.Masivos.forEach(element => {
            if (element.Ciudad == codCiudad) {
                this.sesionStorageService.store("usermasivos",JSON.stringify(element));
            }
        });
        location.reload();
    }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/components/common/cabecera/cabecera.component.ts